export type AuditLogLineProps = {
    data: any;
    text: string;
    time: string;
    type: string;
    user: string;
};

export class AuditLogLine {
    readonly data: any;
    readonly text: string;
    readonly time: string;
    readonly type: string;
    readonly user: string;

    constructor(props: AuditLogLineProps) {
        this.data = props.data;
        this.text = props.text;
        this.time = props.time;
        this.type = props.type;
        this.user = props.user;
    }
}

export type AuditLogResponseProps = {
    lines: AuditLogLineProps[];
};

export class AuditLogResponse {
    readonly lines: AuditLogLine[];

    constructor(props: AuditLogResponseProps) {
        this.lines = (props.lines || []).map((l) => new AuditLogLine(l));
    }
}
